import(/* webpackMode: "eager" */ "/vercel/path0/cohera-frontend/app/error.tsx");
